// Only one swatch stays selected across all four groups
// (swatch / striped / toile / style).
function selectSwatch(link) {
  const root = link.closest('[data-swatch-groups]') || document;

  root.querySelectorAll('[data-swatch-link].is-active').forEach((el) => {
    el.classList.remove('is-active');
  });
  link.classList.add('is-active');

  // Clear every group heading value, then fill only the active group's one
  root.querySelectorAll('[data-swatch-group-value]').forEach((el) => {
    el.textContent = '';
  });

  const row = link.closest('[data-swatch-group]');
  const value = row?.querySelector('[data-swatch-group-value]');
  if (value) value.textContent = link.dataset.title || '';
}

document.addEventListener('click', async (e) => {
  const link = e.target.closest('[data-swatch-link]');
  if (!link) return;
  e.preventDefault();

  const handle = link.dataset.handle;
  if (!handle) return;

  if (link.classList.contains('is-active')) return;

  // Immediate feedback - the fetched section markup confirms it afterwards
  selectSwatch(link);

  // Current page ni actual section ID levo - hardcoded nahi
  const currentEl = document.querySelector('product-component');
  const sectionId = currentEl?.dataset.sectionId;

  if (!sectionId) {
    console.error('Section ID not found on product-component');
    window.location.href = link.href;
    return;
  }

  try {
    const res = await fetch(`/products/${handle}?section_id=${sectionId}`);

    if (!res.ok) throw new Error(`Fetch failed: ${res.status}`);

    const html = await res.text();
    const parser = new DOMParser();
    const newDoc = parser.parseFromString(html, 'text/html');

    const newEl = newDoc.querySelector('product-component');

    if (currentEl && newEl) {
      currentEl.innerHTML = newEl.innerHTML;
    } else {
      console.error('product-component not found in fetched HTML - check section_id');
      throw new Error('Parse failed');
    }

    history.pushState({ handle }, '', `/products/${handle}`);

    const titleTag = newDoc.querySelector('title');
    if (titleTag) document.title = titleTag.textContent;
  } catch (err) {
    console.error('Swatch update failed', err);
    window.location.href = link.href; // fallback
  }
});

window.addEventListener('popstate', () => {
  window.location.reload();
});
